import React from "react";
import HomePage from "./components/HomePage/HomePage";
import "./App.css";
import AboutMe from "./components/AboutMe/AboutMe";
import Projects from "./components/Projects/Projects";
import Project from "./components/Projects/Project";
import Contact from "./components/contact/contact.jsx";
import Footer from "./components/Footer/footer";
import Taskbar from "./components/taskbar/taskbar";
import "bootstrap/dist/css/bootstrap.min.css";


function App() {
  return (
    <div className="body">
      <div className="head" id="home">
        <HomePage />
      </div>
      <div className="About" id="about">
        <AboutMe />
      </div>
      <div className="Projects" id="project">
        {/* <Projects /> */}
        <Project />
      </div>
      <div className="contact" id="contact">
        <Contact />
      </div>
      <div className="footer" id="footer">
        <Footer />
      </div>
    </div>
  );
}

export default App;
